import {Fragment, PureComponent} from 'react'

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx'

import headerImg from '../../../media/images/universes/purchase.jpg?size=600'
import legalImg from '../../../media/images/sub-universes/purchase/legal.jpg?size=600'
import purchaseImg from '../../../media/images/sub-universes/purchase/purchase.jpg?size=600'
import supplyChainImg from '../../../media/images/sub-universes/purchase/supplyChain.jpg?size=600'

const headerBrief = <Fragment>
  <p>Twineeds vous connecte à un <strong>réseau de consultants achats et supply chain</strong> : stratégie sourcing, pilotage des flux, gestion des approvisionnements.<br /><br />Nos <strong>profils qualifiés</strong> sont <strong>disponibles partout en France</strong>, pour assurer vos transformations ou renforcer vos équipes ponctuellement.</p>
</Fragment>

const title = "Boostez vos équipes | Consultants experts | Achats & Supply"
const description = "Rencontrez des profils qualifiés de consultants achats et supply chain pour vos besoins en achats directs, indirects ou projets spécifiques. Rencontrons-nous."

const ourJobsItems = [
  {
    title: 'Achats',
    brief: '<p>Des <strong>experts Achats</strong> pour renforcer vos équipes : <strong>acheteurs IT, consultants SRM, spécialistes des achats indirects et directs, category managers, acheteur industriel</strong>, etc.</p>' +
      '<p>Nos consultants interviennent sur l’ensemble des <strong>achats de production</strong>, qu’ils soient stratégiques ou opérationnels, et qu’ils relèvent du <strong>CAPEX</strong> ou de l’<strong>OPEX</strong>.</p>',
    img: purchaseImg.src,
    imgAlt: 'Poignée de main entre un consultant achats et un professionnel'
  },
  {
    title: 'Supply Chain',
    brief: '<p>Faites appel à des <strong>consultants supply chain expérimentés : responsable logistique, expert en approvisionnement, gestionnaire de flux, demand planner, responsable transport</strong>, etc.</p>',
    img: supplyChainImg.src,
    imgAlt: 'Plateforme logistique dédiée au transport et à la gestion des flux dans la supply chain'
  },
  {
    title: 'Juridique et Contract Management',
    brief: '<p>Des <strong>juristes d’entreprise prêts à intervenir</strong> en mission : <strong>droit social, droit commercial, droit des contrats, propriété intellectuelle, contract management</strong>.</p>',
    img: legalImg.src,
    imgalt: 'Signature d\'un contrat par un consultant RH'
  }
]

const specificDifference = <Fragment><strong>Un réseau de consultants spécialisés</strong> pour structurer vos projets transverses et accompagner le changement.</Fragment>

export default class LandingCompanyPurchase extends PureComponent {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={headerImg.src}
      headerImgAlt="Équipe concentrée sur un projet stratégique devant un PC"
      helmet={{title, description}}
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Trouvez un consultant achats ou supply chain qualifié pour vos missions"
      universeCode="purchase"
    />
  }
}
